@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}

@if (isBusy()) {
  <div class="spinner">
    <div class="busyContents">
      <mat-progress-spinner diameter="60" mode="indeterminate"></mat-progress-spinner>
      <span class="busyLabel">Please Wait...</span>
    </div>
  </div>
}

@if(specialQuote()){
  <div class="dialog-header">
    <span class="spacer"></span>
    <h2>Special Quote Detail</h2>
    <span class="spacer"></span>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
<table>
    <tr>
      <td class="viewTableTd">
        <label class="viewLabel">Quote Number:</label><br> {{ specialQuote().quoteNumber }}
      </td>
      <td class="viewTableTd">
        <label class="viewLabel">Quote Status:</label><br> {{ specialQuote().quoteStatus }}
      </td>
      <td class="viewTableTd">
        <label class="viewLabel">Total Number of Special Units:</label><br> {{ specialQty() }}
      </td>
    </tr>
    <tr>
      <td class="viewTableTd">
        <label class="viewLabel">Setup Fee:</label><br> {{ specialQuote().setupFee | currency }}
      </td>
      <td class="viewTableTd">
        <label class="viewLabel">Price Per Unit:</label><br> {{ specialQuote().pricePerUnit | currency }}
      </td>
      <td class="viewTableTd"></td>
    </tr>
    <tr>
      <td colspan="3">
        <label class="viewLabel">Description:</label><br>{{ specialQuote().description }}
      </td>
    </tr>
  </table>
}
